import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { tracking } from '../utils/tracking';
import { svgs } from '../assets/svgs';
import {
   RegisterCards,
   SponsorSection,
   StatsBanner,
   VideoSection,
   FeaturedSectors,
   SpeakerCards,
   FooterForm,
   TestimonialCarousel,
   Banner,
   DiscountPopup,
   Hero,
} from '../components';
import { imgs } from '../assets/imgs';
// import video from '../assets/videos/homepagevideo.mp4'
import { useResizeImg } from '../hooks/useResizeImg';
import { VCLogos } from '../components/home/VCLogos';
import { useWindowSize } from '../hooks/useWindowSize';
import { updateTags } from '../utils/funcs';

const cards1 = [
   {
      img: imgs.home.registerCard4,
      title: 'INNOVATIVE TECHNOLOGIES',
      content1: 'An exclusive group of startups will be selected to showcase their technology, innovation, and products.',
      content2: 'All presenters are pre-vetted and will put their groundbreaking, innovative, and up-and-coming technology startups on display.',
      btnTxt: 'APPLY TO PRESENT',
      btnLink: 'startups',
      btnId: 277
   },
   {
      img: imgs.home.registerCard5,
      title: 'EXCLUSIVE NETWORKING',
      content1: 'Make connections using the matchmaking platform or at the networking area.',
      content2: 'Connect with and join the ever-growing group of active investors, C-level executives, corporate development professionals, press, and the visionary entrepreneurs that make our summits the premier annual venture experience for many.',
      btnTxt: 'GET YOUR TICKET',
      btnLink: 'registration',
      btnId: 275
   },
   {
      img: imgs.home.registerCard6,
      title: 'INSIGHTFUL CONTENT',
      content1: 'We’re bringing together a fantastic group of top-tier VCs, Corporate VCs and Angel Investors to illuminate the issues facing Investors and Startup CEOs alike, debate what’s next for technology, educate about a wide variety of subjects, and provide updated analyses and share their experience with the audience.',
      content2: '',
      btnTxt: 'APPLY TO SPEAK',
      btnLink: 'speakers',
      btnId: 276
   },
];
const cards2 = [
   {
      img: imgs.home.registerCard1,
      title: 'NOMINATE A COMPANY',
      content1: 'Nominate your colleagues, portfolio companies, or partners for the opportunity to present!',
      content2: '',
      btnTxt: 'NOMINATE A STARTUP',
      btnLink: 'https://youngstartup.com/nominations',
      btnColor: 'var(--color4)',
      btnId: 347
   },
   {
      img: imgs.home.registerCard2,
      title: 'VENTURE NURTURING',
      content1: 'Free access for seed stage startups 25 Tickets Available',
      content2: '*Conditions Apply',
      btnTxt: 'GET MORE DETAILS',
      btnLink: 'venture-nurturing',
      btnColor: 'var(--color5)',
      btnId: 348
   },
   {
      img: imgs.home.registerCard3,
      title: 'PRESS PASSES',
      content1: 'If you qualify and would like a press pass, visit here for details.',
      content2: '',
      btnTxt: 'GET YOUR PRESS PASS',
      btnLink: 'press',
      btnColor: 'var(--color6)',
      btnId: 281
   },
];

const vidUrl = "https://www.youtube.com/embed/9o0uXtzun58?modestbranding=1&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&playlist=9o0uXtzun58";
const vidHeader = "VIDEO HIGHLIGHTS";

export const Home = () => {
   const [isLoading, setIsLoading] = useState(true)
   const imageSource = useResizeImg(imgs.home.desktopBanner, imgs.home.mobileBanner)
   const collageImageSource = useResizeImg(imgs.home.desktopCollage, imgs.home.mobileCollage)
   const size = useWindowSize()

   useEffect(() => {
      updateTags("Venture Summit West | Silicon Valley, April 2024")
  }, [])

   return (
      <div className='home'>
         <Hero />
         <StatsBanner />
         <SpeakerCards isSliced={true} />
         <RegisterCards cards={cards1} />
         <VideoSection url={vidUrl} header={vidHeader} />
         <FeaturedSectors />
         <TestimonialCarousel pageName={"overview;"} />
         <img src={collageImageSource} alt="collage-Image" />
         {/* <RegisterCards cards={cards2} /> */}
         <SponsorSection />
         <FooterForm />
      </div>
   )
}